var render = function render(){var _vm=this,_c=_vm._self._c;return _c('McEmptyState',{attrs:{"title":_vm.title,"desc":_vm.desc,"buttonText":_vm.buttonText,"buttonTextSecondary":_vm.buttonTextSecondary,"img":_vm.img,"buttonIco":_vm.buttonIco},on:{"buttonPrimaryAction":function($event){return _vm.buttonPrimaryAction()},"buttonSecondaryAction":function($event){return _vm.buttonSecondaryAction()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }